// ─── CALENDAR EVENT CACHE ──────────────────────────────────────────────────────
// Thin in-memory wrapper around gcal.fetchEvents so components that want
// overlapping/repeated date windows (Home's Today/Coming Up + This/Next Week
// cards) can share results instead of each firing its own network call.
// Cleared on full page reload by design — this is a session-lifetime cache,
// not persisted storage.

import { fetchEvents } from './gcal';

const cache = new Map(); // key -> { events, fetchedAt }

function cacheKey({ calendarId, timeMin, timeMax }) {
  return `${calendarId}::${timeMin}::${timeMax}`;
}

// Returns cached events if fresher than ttlMs, otherwise fetches and caches.
export async function getEventsCached({ calendarId, timeMin, timeMax, maxResults, ttlMs = 90_000 }) {
  const key = cacheKey({ calendarId, timeMin, timeMax });
  const hit = cache.get(key);
  if (hit && Date.now() - hit.fetchedAt < ttlMs) return hit.events;

  const events = await fetchEvents({ calendarId, timeMin, timeMax, maxResults });
  cache.set(key, { events, fetchedAt: Date.now() });
  return events;
}

// Call after any mutation that changes calendar data visible on Home
// (assign, lock in, coverage accept, pickup override, etc.) so the next
// read doesn't serve stale results for the rest of the TTL window.
export function invalidateCalendarCache() {
  cache.clear();
}
